/* global BigInt */
// Presentation only: decimal strings retain their stored/calculation precision.
export default function formatRate(value) {
  if (value == null || !/^\d+(?:\.\d+)?$/.test(String(value))) return null;
  const [whole, fraction = ''] = String(value).split('.');
  const cents = BigInt(whole) * 100n + BigInt(`${fraction}00`.slice(0, 2));
  const rounded = cents + (Number(fraction[2] || '0') >= 5 ? 1n : 0n);
  return `${rounded / 100n}.${String(rounded % 100n).padStart(2, '0')}`;
}
